import { render } from "./ConsumedList.vue?vue&type=template&id=97d60342&scoped=true"
import script from "./ConsumedList.vue?vue&type=script&lang=js"
export * from "./ConsumedList.vue?vue&type=script&lang=js"

import "./ConsumedList.vue?vue&type=style&index=0&id=97d60342&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97d60342"]])

export default __exports__